import { Button } from "common/commonIndex";
import React from "react";
import { useNavigate } from "react-router-dom";

const QuestionnaireAlertPopup = ({ questionnaireComplete, setIsQuestCompletePopup }) => {
const navigate = useNavigate();
    const handleRedirect = () => {
       const redirectUrl = `/questionnaire?fkUserId=${questionnaireComplete?.providerId}&appointmentId=${questionnaireComplete?.appointmentId}&step=0`;
        navigate(redirectUrl);
        setIsQuestCompletePopup(false);
    }

    const closePopup = () => {
        setIsQuestCompletePopup(false);
    }

    return (
        <>
            {questionnaireComplete && (
                <div className="">
                    <h2 className="title mb-0 pt-2">
                        Alert
                    </h2>
                    <div className="alert-container pt-3">
                        <p className="alert-description">
                            Would you like to continue where
                            you left off and complete the
                            questionnaire?
                        </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-5">
                        <Button btnClass={`cancel-btn`}
                            btnName={'No'}
                            btnType={'button'}
                            onClick={closePopup}
                            isDisabled={true}
                        />
                        <Button btnClass={`btn-primary`}
                            btnName={'Yes'}
                            btnType={'button'}
                            onClick={handleRedirect}
                            isDisabled={true}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default QuestionnaireAlertPopup;